import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import SearchFeed from './components/SearchFeed';
import { TEnvConfig } from 'types/TServerContext';
import './components/SearchFeed.scss';

type TSearchFeedAppProps = {
  searchResult: any;
  searchCategories?: any;
  searchFilters?: any;
  searchLink?: string;
  environment: TEnvConfig;
};

const SearchFeedApp = ({
  environment,
  searchResult,
  searchCategories,
  searchFilters,
  searchLink,
}: TSearchFeedAppProps) => {
  return (
    <EnvironmentProvider value={environment}>
      <SearchFeed
        searchResult={searchResult}
        searchCategories={searchCategories}
        searchFilters={searchFilters}
        searchLink={searchLink}
      />
    </EnvironmentProvider>
  );
};

export default SearchFeedApp;
